import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { MessageCircle, X } from 'lucide-react';
import { Card } from './ui/card';

// Shared signup card shown below a calculator result. It offers to send the
// breakdown to MoneyFeed on WhatsApp, or to create a free MoneyFeed account.
// Dismissal is local state only: the card hides for the rest of the page view.
// resultTotal is an already-formatted total (for example "$13,567"); when it
// is provided it is appended to the WhatsApp message.
export default function ResultSignupCard({ resultTotal }) {
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) {
    return null;
  }

  const baseMessage =
    'Hi MoneyFeed! I just estimated my taxes with your calculator and want to track them properly.';
  const message = resultTotal
    ? `${baseMessage} My estimate came to ${resultTotal}.`
    : baseMessage;
  const whatsappUrl = `https://wa.me/17373163545?text=${encodeURIComponent(message)}`;

  return (
    <Card
      data-testid="result-signup-card"
      className="relative bg-white shadow-lg rounded-3xl p-6"
    >
      <button
        type="button"
        aria-label="Dismiss"
        data-testid="result-signup-card-dismiss"
        onClick={() => setDismissed(true)}
        className="absolute top-3 right-3 text-gray-400 hover:text-gray-700 text-xl leading-none"
      >
        <X className="h-5 w-5" />
      </button>
      <h3 className="text-lg font-bold text-[#064E3B] pr-8">
        Don't just estimate it — track it.
      </h3>
      <p className="text-sm text-gray-600 mt-2">
        Send this breakdown to MoneyFeed on WhatsApp. Log every expense by text
        or photo, and your books stay tax-ready all year — with whichever
        bookkeeping app you already use.
      </p>
      <div className="flex flex-col items-start gap-2 mt-4">
        <a
          href={whatsappUrl}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="result-signup-card-whatsapp"
          className="inline-flex items-center gap-2 bg-[#84CC16] hover:bg-[#65A30D] text-black font-bold rounded-full px-5 py-2.5 text-sm transition-colors"
        >
          <MessageCircle className="h-4 w-4" />
          Get it on WhatsApp
        </a>
        <Link
          to="/auth"
          data-testid="result-signup-card-account"
          className="text-sm font-semibold text-[#064E3B] hover:text-[#65A30D] transition-colors"
        >
          or create a free MoneyFeed account
        </Link>
      </div>
    </Card>
  );
}
